import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en.json'
import zh from './locales/zh.json'
import es from './locales/es.json'

Vue.use(VueI18n)

export default new VueI18n({
    locale: 'en', // default locale
    fallbackLocale: 'en',
    messages: {
        en,
        zh,
        es
    }
})
